<template>
  <div class="mtable-tool-selPage" v-if="selPage">
    <span>{{multiLanguage.clauses_text}}：</span>
    <Dropdown class="pull-right" >
      <button data-role="trigger" class="btn btn-default dropdown-toggle" type="button">
        <span>{{selPage.list[selPage.active]}}</span>
        <span class="caret"></span>
      </button>
      <template v-if="selPage" v-for="(item,index) in selPage.list" slot="dropdown" :class="{hide :selPage.list.length >= 1}">
        <li @click="emitSelPage(index, item)"><a href="#">{{item}}</a></li>            
      </template>
    </Dropdown> 
  </div>
</template>

<script>
  import { Dropdown } from 'uiv'
  import { mapMutations, mapState } from 'vuex'

  export default {
    props: [
      "multiLanguage",
      "selPage"
    ],
    data () {
      return {}
    },
    mounted () {
      if (!this.selPage.active) this.$parent.selPage.active = 0
    },
    methods: {
      emitSelPage (index, item) {
        this.$emit("selPage", index, item)
      }
    },
    components: {
      Dropdown
    }
  }
</script>

<style lang="scss" type="text/scss">
  .seek{
    display: inline-block;
    vertical-align: top;
    font-size: 0;
    .seekDropdown{
      display: inline-block;
      vertical-align: top;
      font-size: 13px;
      .dropdown-toggle{
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
      }
    }
    .form-group{
      display: inline-block;
      vertical-align: top;
      position: relative;
      margin: 0;
      .form-control{
        min-width: 145px;
        font-size: 13px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    .btn-default{
      display: inline-block;
      vertical-align: top;
      font-size: 13px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
</style>





// WEBPACK FOOTER //
// selPage.vue?23830ca8